//GeneratorFlag:[NoChange]
import VirtualFolder from './virtual-folder';
import VirtualFolderFilter from './virtual-folder-filter';

export default {VirtualFolder, VirtualFolderFilter}
export{VirtualFolder, VirtualFolderFilter}